import { QueryClient } from '@tanstack/react-query'

/**
 * Singleton TanStack Query client for the admin SPA.
 * Configured with conservative defaults — stories may tune per-feature.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      refetchOnWindowFocus: false,
      retry: 1,
    },
    mutations: {
      retry: 0,
    },
  },
})
